/**
 * class Playlist used on ordernumber or videonumber detail page
 */
export default class Playlist {
    constructor() {
        this.tracking = null; // adobe tracking
        this.utagClick = null; // tealium tracking
        this.autoplay = true;
        this.index = 0; // current video
        this.player = null; // video element
        this.playerTitle = null;
        this.playerBtnPrev = null;
        this.playerBtnNext = null;
        this.progress = 0; // progress in percent
        this.thumbsContainer = null; // thumbnail
        this.thumbsWrap = null;
        this.thumbsBtnUp = null;
        this.thumbBtnDown = null;
        this.videos = []; // video object array
        this.firstPlay = true; // add firstPlay property to add a delayed tracking event. without that it would not be tracked in some circumstances till AA is loaded.

        // touch event properties
        this.xDown = null;
        this.yDown = null;
        this.xDiff = 0;
        this.yDiff = 0;
        this.swipeThreshold = 100;
    }

    init(options) {
        this.videos = options.videos || [];
        this.tracking = options.tracking || null;
        this.utagClick = options.utagClick || null;

        if (this.videos.length === 0) {
            // if there are no videos. show some info.
            this.videos.push({
                src: '',
                thumbnail: 'https://via.placeholder.com/640x360?text=Keine+Videos+gefunden',
                caption: 'Keine Videos gefunden',
                type: ''
            });
        }

        let uiAutoplay = document.getElementById('playlist-autoplay');
        uiAutoplay.onchange = function () {
            if (this.autoplay === true) {
                this.autoplay = false;
            } else {
                this.autoplay = true;
            }
        }.bind(this);

        this.playerTitle = document.getElementById('playlist-player-title');
        this.player = document.getElementById('playlist-player');
        this.player.muted = false;
        this.player.autoplay = false;
        this.player.onended = function () {

            // tracking ended
            SK.tracking.Event(
                'VideoWatchFull',
                this.tracking.getCurrentTrackingData()
            );

            let utagComplete = this.utagClick.getUtagClickOptions();
            utagComplete.link_action = 'complete';
            utag.link(utagComplete);
            console.log('🌞 utag.link()', utagComplete);

            if (this.autoplay) {
                this.next();
            }
        }.bind(this);
        this.player.onerror = function () {
            this.player.poster = 'https://via.placeholder.com/640x360?text=Oops.+Video+nicht+gefunden.';
        }.bind(this);
        this.player.onpause = function () {
            this.resetThumbsStatus().setThumbStatus('paused');
        }.bind(this);
        this.player.onplay = function () {
            this.resetThumbsStatus().setThumbStatus('playing');
        }.bind(this);

        let handlePlayerTouchStart = function (evt) {
            this.xDown = evt.touches[0].clientX;
            this.yDown = evt.touches[0].clientY;
            this.xDiff = 0;
            this.yDiff = 0;
        }.bind(this);

        let handlePlayerTouchMove = function (evt) {
            if (!this.xDown || !this.yDown) {
                return;
            }

            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;

            this.xDiff = this.xDown - xUp;
            this.yDiff = this.yDown - yUp;

        }.bind(this);

        let handlePlayerTouchEnd = function (evt) {
            if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {/*most significant*/
                if (Math.abs(this.xDiff) > this.swipeThreshold) {
                    if (this.xDiff > 0) {
                        // swiped right
                        this.next();
                    } else {
                        // swiped left
                        this.prev();
                    }
                }
            } else {
                // if (this.yDiff > 0) {
                //     console.log('swiped up');
                // } else {
                //     console.log('swiped down');
                // }
            }
            /* reset values */
            this.xDown = null;
            this.yDown = null;
        }.bind(this);

        this.player.addEventListener('touchstart', handlePlayerTouchStart, false);
        this.player.addEventListener('touchmove', handlePlayerTouchMove, false);
        this.player.addEventListener('touchend', handlePlayerTouchEnd, false);

        this._play(0);
        this.thumbsContainer = document.getElementById('playlist-thumbnails');
        this.thumbsContainer.addEventListener('scroll', (evt) => {
            this.scrollThumbsArrows();
        });
        this.thumbsWrap = document.getElementById('thumbnails-wrap');
        this.thumbsWrap.innerHTML = this.getAllThumbs();
        this.thumbsBtnUp = document.getElementById('thumbnails-btn-up');
        this.thumbsBtnUp.onmousedown = function (evt) {
            this.scrollThumbs('up');
            evt.preventDefault();
        }.bind(this);
        this.thumbsBtnDown = document.getElementById('thumbnails-btn-down');
        this.thumbsBtnDown.onmousedown = function (evt) {
            this.scrollThumbs('down');
            evt.preventDefault();
        }.bind(this);
        setTimeout(function () {
            this.visibilityThumbsArrows();
            this.visibilityPlayerArrows();
        }.bind(this), 1000);

        this.playerBtnPrev = document.getElementById('player-btn-prev');
        this.playerBtnPrev.onmousedown = function (evt) {
            this.prev();
            evt.preventDefault();
        }.bind(this);

        this.playerBtnNext = document.getElementById('player-btn-next');
        this.playerBtnNext.onmousedown = function (evt) {
            this.next();
            evt.preventDefault();
        }.bind(this);
    }

    scrollThumbs(dir) {
        if (dir === 'up') {
            this.thumbsContainer.scrollTo({
                top: this.thumbsContainer.scrollTop -= 220,
                behavior: 'smooth'
            });
        } else {
            this.thumbsContainer.scrollTo({
                top: this.thumbsContainer.scrollTop += 220,
                behavior: 'smooth'
            });
        }
        this.scrollThumbsArrows();
    }

    visibilityThumbsArrows() {
        if (this.thumbsWrap.offsetHeight > this.thumbsContainer.offsetHeight) {
            this.scrollThumbsArrows();
        }
    }

    visibilityPlayerArrows() {
        if (this.videos.length <= 1) {
            this.playerBtnPrev.classList.add('hidden');
            this.playerBtnNext.classList.add('hidden');
        }
    }

    scrollThumbsArrows() {
        if (
            this.thumbsWrap.offsetHeight > this.thumbsContainer.offsetHeight
        ) {
            this.thumbsBtnDown.classList.add('visible');
        }
        if (this.thumbsContainer.scrollTop === this.thumbsWrap.offsetHeight - this.thumbsContainer.offsetHeight) {
            this.thumbsBtnDown.classList.remove('visible');
        }

        if (this.thumbsContainer.scrollTop > 0) {
            this.thumbsBtnUp.classList.add('visible');
        }
        if (this.thumbsContainer.scrollTop === 0) {
            this.thumbsBtnUp.classList.remove('visible');
        }
    }

    play(index) {
        if (index || index === 0) {
            this.index = index;
        }
        this._play(this.index);
        this.player.play();
    }

    _play(index) {
        if (this.videos[index].src !== '') {
            this.player.src = this.videos[index].src;
        }
        this.player.poster = this.videos[index].thumbnail;
        this.player.title = this.videos[index].caption;

        // hide Live TV caption displayed over video player
        let caption = (this.getByIndex(index).caption !== 'Live TV') ? this.getByIndex(index).caption : '';
        this.playerTitle.innerHTML = caption;

        this.toggleModeratorText(index);

        // tracking start playing
        this.tracking.updateWithVideoData(this.videos[index]);
        this.utagClick.updateWithVideoData(this.videos[index]);

        if (this.firstPlay) {
            this.firstPlay = false;
            setTimeout(function () {
                SK.tracking.Event(
                    'VideoWatchStart',
                    this.tracking.getCurrentTrackingData()
                );

                utag.link(this.utagClick.getUtagClickOptions());
                console.log('🌞 utag.link()', this.utagClick.getUtagClickOptions());

            }.bind(this), 2000);
        } else {
            SK.tracking.Event(
                'VideoWatchStart',
                this.tracking.getCurrentTrackingData()
            );

            utag.link(this.utagClick.getUtagClickOptions());
            console.log('🌞 utag.link()', this.utagClick.getUtagClickOptions());

        }
    }

    /**
     * at the moment there is only one moderator text for the first video
     * if the mediathek api works correct, hopefully.
     * if the player jumps to the next video the moderator text element
     * is hidden and will be shown again if the first video plays again.
     * @todo/improvement: moderator text for all videos in future?
     *
     * @param index
     */
    toggleModeratorText(index) {
        let moderatorText = document.getElementById('moderator-text');
        if (moderatorText) {
            if (index === 0) {
                moderatorText.classList.remove('hidden');
            } else {
                moderatorText.classList.add('hidden');
                moderatorText.classList.remove('opened');
            }

        }
    }

    toggle(index) {
        if (this.index !== index) {
            this.index = index;
            this.play();
        }
        let thumb = document.getElementById('thumb-' + index);
        if (thumb.classList.contains('playing')) {
            this.player.pause();
            return;
        }
        if (thumb.classList.contains('paused')) {
            this.player.play();
            return;
        }
        thumb.classList.add('playing');
        this.player.play();
    }

    next() {
        this.index++;

        if (this.index > this.videos.length - 1) {
            this.index = -1;
            return this.next();
        }
        this.play();
        return this.current();
    }


    prev() {
        this.index--;

        if (this.index < 0) {
            this.index = this.videos.length;
            return this.prev();
        }
        this.play();
        return this.current();
    }


    current() {
        return this.videos[this.index];
    }

    first() {
        return this.videos[0];
    }

    last() {
        return this.videos[this.videos.length - 1];
    }

    getByIndex(i) {
        return this.videos[i];
    }

    reset() {
        this.current = -1;
    }

    getAllThumbs() {
        let thumbs = '';
        for (let i = 0; i < this.videos.length; i++) {
            thumbs += this.getThumb(i);
        }
        return `${thumbs}`;
    }

    resetThumbsStatus() {
        let thumbs = document.getElementsByClassName('thumb');
        for (let i = 0; i < thumbs.length; i++) {
            thumbs[i].classList.remove('selected');
            thumbs[i].classList.remove('playing');
            thumbs[i].classList.remove('paused');
        }
        return this;
    }

    setThumbStatus(state) {
        let thumb = document.getElementById('thumb-' + this.index);
        thumb.classList.add('selected');
        thumb.classList.add(state);
        return this;
    }

    getThumb(index) {
        //let state = this.index === index ? 'selected playing' : '';
        let state = '';
        let caption = (this.getByIndex(index).caption !== 'Live TV') ? this.getByIndex(index).caption : '';
        return `
<figure id="thumb-${index}" class="fa thumb ${state}" onclick="SK.playlist.toggle(${index});">
    <div class="progress progress-${index}" style="height: 3px; width: 0px; background-color: #00AED5; position:absolute; z-index: 9999;"></div>
    <span class="overlay"> </span>
    <img onerror="SK.helper.setDefaultImage(this);" src="${this.getByIndex(index).thumbnail}" alt="${this.getByIndex(index).caption}" title="${this.getByIndex(index).caption}"/>
    <figcaption>${this.getByIndex(index).caption}</figcaption>
</figure>`;
    }
};